import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import focalPointApiClient from 'Services/Apis/FocalPoint/conciergeApiClient';

export const getListDistributionThunk = createAsyncThunk(
    `GetListDistributionSlicer/getListDistributionThunk`,
    async ({ creditRequestId }, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
        };

        const { data } = await focalPointApiClient.get(
            `/DistributionAvailableAndHistory/get-credit-request-transaction?creditRequestId=${creditRequestId}`,
            {
                headers,
            });
        return data;
    }
);

const initialState = {
    dataGetListDistribution: {},
    loadingGetListDistribution: false,
    errorGetListDistribution: false,
};

const GetListDistributionSlicer = createSlice({
    name: 'GetListDistribution',
    initialState,
    reducers: {
        resetDataGetListDistribution: (state) => {
            state.dataGetListDistribution = {};
            state.loadingGetListDistribution = false;
            state.errorGetListDistribution = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getListDistributionThunk.pending, (state) => {
            state.dataGetListDistribution = {};
            state.loadingGetListDistribution = true;
            state.errorGetListDistribution = false;
        });
        builder.addCase(getListDistributionThunk.fulfilled, (state, action) => {
            state.dataGetListDistribution = action.payload;
            state.loadingGetListDistribution = false;
            state.errorGetListDistribution = false;
        });
        builder.addCase(getListDistributionThunk.rejected, (state) => {
            state.dataGetListDistribution = {};
            state.loadingGetListDistribution = false;
            state.errorGetListDistribution = true;
        });
    },
});

export const { resetDataGetListDistribution } = GetListDistributionSlicer.actions;
export default GetListDistributionSlicer.reducer;